var React = require('react');

function BasicMail (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"basic_mail_Background_Mask_2"},React.createElement("path",{"id":"basic_mail-2","d":"M20 20H4a2 2 0 0 1-2-2V5.914A2 2 0 0 1 4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zM4 7.869V18h16V7.869L12 13.2zM4.8 6l7.2 4.8L19.2 6z"})));
}

BasicMail.defaultProps = {"id":"basic_mail","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BasicMail;

BasicMail.default = BasicMail;
